module.exports = __webpack_public_path__ + "static/media/person.6f8100fb.svg";